<kendo-grid-numeric-filter-menu
  [column]="column"
  [filter]="filter"
  [filterService]="pctFilterService"
></kendo-grid-numeric-filter-menu>
